import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Chip,
} from "@mui/material";
import Sidebar from "./Sidebar";
import MenuIcon from "@mui/icons-material/Menu";
import { getCurrentUserData } from "../api/Authentication/api";
import UserProfileModal from "./UserProfileModal";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [user, setUser] = useState(null);
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  React.useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getCurrentUserData();
        setUser(userData.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "#F8FAFC",
        overflowX: "hidden",
      }}
    >
      <Sidebar open={sidebarOpen} />
      <Box sx={{ flexGrow: 1, overflowX: "hidden" }}>
        <AppBar
          position="static"
          color="default"
          elevation={0}
          sx={{
            bgcolor: "#124F3E",
            borderBottom: "1px solid #E2E8F0",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              onClick={toggleSidebar}
              sx={{ mr: 2, color: "white" }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h2"
              component="div"
              sx={{ flexGrow: 1, color: "white" }}
            >
              ONE ACRE FUND
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box sx={{ textAlign: "right" }}>
                <Typography
                  variant="body1"
                  sx={{ color: "white", fontWeight: "medium" }}
                >
                  {user?.name || "Loading..."}
                </Typography>
                <Chip
                  label={user?.role?.name || "Loading..."}
                  size="small"
                  sx={{
                    bgcolor: "rgba(255, 255, 255, 0.1)",
                    color: "white",
                    "& .MuiChip-label": { px: 1 },
                  }}
                />
              </Box>
              <IconButton
                sx={{
                  p: 0.5,
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    bgcolor: "rgba(255, 255, 255, 0.2)",
                  },
                }}
                onClick={() => setProfileModalOpen(true)}
              >
                <Avatar
                  alt={user?.name}
                  src="/avatar.png"
                  sx={{ width: 36, height: 36 }}
                />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Outlet />
        </Box>
      </Box>
      <UserProfileModal
        open={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
        user={user}
      />
    </Box>
  );
};

export default Layout;
